import { Component, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import {
    SonaBarChartDirective,
    SonaChartComponent
} from '@sona/angular-ui-components/charts';
import { SonaDeviceTypeNamePipe } from '@sona/angular-util-common';
import { HistoricalReport, Issues } from '@sona/shared-reports-models';
import { BrnSeparatorComponent } from '@spartan-ng/brain/separator';
import { HlmSeparatorDirective } from '@spartan-ng/ui-separator-helm';

import { createIssueHistoryByDeviceType } from '../charts/options/issue-history-by-device-type';
import { SonaReportMetricComponent } from '../metric.ng';

import { SonaChartCardComponent } from './chart-card.ng';

@Component({
    selector: 'sona-issue-history-card',
    imports: [
        SonaChartCardComponent,
        SonaReportMetricComponent,
        BrnSeparatorComponent,
        HlmSeparatorDirective,
        SonaBarChartDirective,
        SonaChartComponent,
        SonaDeviceTypeNamePipe,
        TranslatePipe
    ],
    template: `
        <sona-chart-card
            icon="warning"
            [title]="'REPORTS.COMPONENT.ISSUE_HISTORY_CARD.TITLE' | translate"
        >
            <div class="tw-flex tw-items-center" ngProjectAs="sona-report-metric">
                <sona-report-metric
                    [name]="'mobile' | sonaDeviceTypeName | translate"
                    [value]="currentValue()?.mobile?.value"
                    [change]="{
                        value: currentValue()?.mobile?.change,
                        ratingMethod: 'inverse'
                    }" />
                <brn-separator hlmSeparator class="tw-h-12 tw-mx-4" orientation="vertical" />
                <sona-report-metric
                    [name]="'desktop' | sonaDeviceTypeName | translate"
                    [value]="currentValue()?.desktop?.value"
                    [change]="{
                        value: currentValue()?.desktop?.change,
                        ratingMethod: 'inverse'
                    }" />
            </div>
            <sona-chart
                barChart
                [group]="group()"
                [options]="_issueHistoryByDeviceType()" />
        </sona-chart-card>
    `
})
export class SonaIssueHistoryCardComponent {

    readonly group = input<string>();
    readonly chartLength = input<number>(10);
    readonly history = input<HistoricalReport[]>();
    readonly currentValue = input<Issues>();

    protected readonly _issueHistoryByDeviceType = createIssueHistoryByDeviceType(this.history, this.chartLength);
}
